import React, { useEffect, useState } from "react";
import { CircularProgress, Divider, Card as MuiCard, Typography, Box } from "@material-ui/core";
import useStyles from "../../assets/styles/styles";
import { CardContent, IconButton } from '@material-ui/core';
import MenuProfile from '../Menu/MenuProfile';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from "react-router";
import TimerOffIcon from '@mui/icons-material/TimerOff';
import { useDispatch, useSelector } from "react-redux";
import { getMedicalAgenda } from '../../redux/actions/appointmentsActions';
import { format } from "date-fns";
import { useLocation } from 'react-router-dom';
import FaceIcon from "@material-ui/icons/Face";
import CustomButton from "../../controls/Button/CustomButton";
import ModalCallPatient from "../DialogActivities/ModalCallPatient";
import { isValidReceptionDate } from "../../utils/utilsFunctions";

const userCode = parseInt(window.localStorage.getItem("numeroPersona"));


const PatientDetails = ({ }) => {

    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const { codeMedicalCenters, medicalCenters, codeSpecialty, agendaMedical, selectedDay, closestTurn, lastTurnOfDay, centro, especialidad, businessHours } = location.state || {};
    const modelAgendaMedicalReducer = useSelector(state => state.appointmentsReducer);
    const [modelAgendaMedical] = useState(modelAgendaMedicalReducer?.medicalAgenda);
    const date = new Date();
    const [totalTurns, setTotalTurns] = useState(0);
    const [assignedTurns, setAssignedTurns] = useState(0);
    const [timeoutError, setTimeoutError] = useState(false);
    const horariosUnicos = Array.from(new Set(businessHours.split(" | ")));
    const isLoading = useSelector(state => state.appointmentsReducer.isLoading);
    const [openCallModal, setOpenCallModal] = useState(false);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [callAttempts, setCallAttempts] = useState(0);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const typeAttentionMap = {
        A: "Adicional",
        E: "Espontáneo",
        P: "Presencial",
        R: "Remota",
        W: "Presencial",
    };


    const getServiceTypeDescription = (i) => {
        if (!i) return "";
        return typeAttentionMap[i.toUpperCase()];
    };

    useEffect(() => {
        const savedParams = localStorage.getItem('medicalAgendaParams');
        let paramAll;

        if (savedParams) {
            paramAll = JSON.parse(savedParams);
        } else {
            paramAll = {
                fechaDesde: selectedDay,
                fechaHasta: selectedDay,
                numeroPersona: userCode,
                medicoCodigo: modelAgendaMedical?.medicoCodigo ? modelAgendaMedical.medicoCodigo.toString() : undefined,
                parametroAgenda: "TOMADOS",
            };
        }

        const timeoutId = setTimeout(() => {
            if (isLoading) {
                setTimeoutError(true);
            }
        }, 40000);

        dispatch(getMedicalAgenda(paramAll));

        return () => clearTimeout(timeoutId);

    }, []);



    const getFilteredAppointments = () => {
        if (!codeMedicalCenters || !codeSpecialty || !agendaMedical || !medicalCenters || !selectedDay || !closestTurn
            || !lastTurnOfDay || !centro || !especialidad || !businessHours) return [];

        return modelAgendaMedicalReducer?.medicalAgenda?.agenda?.filter(
            (turno) => {
                const turnoFecha = format(new Date(turno.turnoFechHora), "yyyy-MM-dd");
                
                return turno?.centroMedicoDescripcion === centro &&
                       turno?.especialidadDescripcion === especialidad &&
                       turno?.estadoTurno?.toUpperCase().trim() === "ASIGNADO" &&
                       turnoFecha === selectedDay;
            }
        );

    };

    useEffect(() => {
        if (agendaMedical?.length > 0) {
            const dateAgendaMedical = agendaMedical?.filter(turno => {
                return new Date(turno?.turnoFechHora) > date;
            });

            if (dateAgendaMedical.length > 0) {
                const closest = dateAgendaMedical.reduce((prev, current) => {
                    return new Date(prev?.turnoFechHora) < new Date(current?.turnoFechHora) ? prev : current;
                });

                const lastTurn = dateAgendaMedical.filter(turno => {
                    return new Date(turno?.turnoFechHora).toDateString() === new Date(closest?.turnoFechHora).toDateString();
                }).reduce((prev, current) => {
                    return new Date(prev?.turnoFechHora) > new Date(current?.turnoFechHora) ? prev : current;
                });

                const dayShifts = dateAgendaMedical.filter(turno => {
                    return new Date(turno?.turnoFechHora).toDateString() === new Date(closest?.turnoFechHora).toDateString();
                });

                const totalTurns = dayShifts.length;
                const assignedTurns = getFilteredAppointments()?.length;
                setTotalTurns(totalTurns);
                setAssignedTurns(assignedTurns);
            }
        }
    }, [modelAgendaMedicalReducer, date]);

    const centeredCircularProgress = () => {
        return (
            <div className={` ${classes.medicalCalendarLoadingIcon} ${classes.circularProgress}`}>
                <CircularProgress />
            </div>
        );
    }

    const formatSelectedDay = (dateString) => {
        const date = new Date(dateString + "T12:00:00");
        const options = { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' };
        const formattedDate = new Intl.DateTimeFormat('es-ES', options).format(date);
        const cleanFormattedDate = formattedDate.replace(',', '').replace(/\//g, '-');

        return cleanFormattedDate.charAt(0).toUpperCase() + cleanFormattedDate.slice(1);
    };



    const callPatient = async (patient) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({ success: true });
            }, 1000);
        });
    };

    const handleCallButton = async (patient) => {
        setSelectedPatient(patient);
        await callPatient(patient);
        setOpenCallModal(true);
        setCallAttempts(prev => prev + 1);
        setIsButtonDisabled(true);
        startCountdown();
    };

    const startCountdown = () => {
        setCountdown(15);
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    setIsButtonDisabled(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const handleRetry = async () => {
        if (callAttempts >= 3) {
            setOpenCallModal(false);
            return;
        }
        await callPatient(selectedPatient);
        setCallAttempts(prev => prev + 1);
        setIsButtonDisabled(true);
        startCountdown();
    };

    const handleEnter = () => {
        history.push('/MedicalHistory', { 
            patient: selectedPatient,
            codeMedicalCenters,
            medicalCenters,
            codeSpecialty,
            agendaMedical,
            selectedDay,
            closestTurn,
            lastTurnOfDay,
            centro,
            especialidad,
            businessHours
        });
        setOpenCallModal(false);
    };


    const resetCallState = () => {
        setCallAttempts(0);
        setCountdown(0);
        setIsButtonDisabled(false);
        setSelectedPatient(null);
    };


    const handleCloseModal = () => {
        setOpenCallModal(false);
        resetCallState();
    };


    return (
        <>
            <MenuProfile />
            <Box className={classes.headerPatientAgenda}>
                <IconButton onClick={() => history.push('/CalendarMedical')}>
                    <ArrowBackIcon className={classes.iconFilter} />
                </IconButton>
                <Typography className={classes.detailPatient}>{formatSelectedDay(selectedDay)}</Typography>
                <Box>
                    <Typography className={classes.detailPatientCenterSpecialty} >
                        {centro}
                    </Typography>
                    <Typography className={classes.detailPatientCenterSpecialty}>
                        {" | "}{especialidad}
                    </Typography>
                </Box>
                <Divider className={`${classes.formDivider} ${classes.dividerAppointment}`} />
            </Box>

            <Box className={`${classes.divSectionMovements}`} >
                <Box className={`${classes.detailPatientInfoSection}`}>
                    <Box className={`${classes.detailCardAgendaMedical}`}>
                        <Box className={`${classes.detailPatientInfoTurno}`}>
                            <Typography className={`${classes.detailPatientOpeningHours}`}>
                                Horario de Atención:
                            </Typography>
                            <Typography className={`${classes.detailPatientTotalTurno}`}>
                                Turnos
                            </Typography>
                            <Typography className={`${classes.detailPatientTurnoAssigned}`}>
                                Asignados
                            </Typography>
                            <Typography className={`${classes.txtCardDescriptionHourTurnDetailPatient}`} >
                                {horariosUnicos.map((horario, index) => {
                                    const horas = horario.split(" - ").map((hora) => {
                                        const horaConHs = `${hora.charAt(0).toUpperCase()}${hora.slice(1)}`;
                                        return horaConHs.replace(/hs/g, "Hs.")
                                    });
                                    return (
                                        <Typography sx={{ fontSize: "inherit" }} component="span" key={index} className={`${classes.txtHorariosUnicosPatientAgenda}`}>
                                            {horas[0]} {horas[1]}
                                            {index < Object.keys(horariosUnicos).length - 1 && (
                                                <>
                                                    {" "}
                                                    <Typography sx={{ fontSize: "inherit" }} component="span" className={`${classes.medicalAgendaDivision}`}>
                                                        |{" "}
                                                    </Typography>
                                                </>
                                            )}
                                        </Typography>
                                    );
                                })}
                            </Typography>
                            <Typography className={`${classes.detailAgendaMedical}`}>
                                {totalTurns}
                            </Typography>
                            <Typography className={`${classes.detailAgendaMedical}`}>
                                {assignedTurns}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box className={`${classes.divSectionDetailPatient}`} >
                {timeoutError ? (
                    <Typography className={classes.txtIconTimeOutPatientAgenda}>
                        <TimerOffIcon className={classes.IconTimeOutPatientAgenda} />
                        La solicitud ha tardado demasiado. Por favor, inténtelo de nuevo más tarde.
                    </Typography>
                ) : modelAgendaMedicalReducer.isLoading ? (
                    centeredCircularProgress()
                ) : (
                    <Box className={`${classes.divSectionMovementsDetailPatientMedicalAgenda}`}>
                        {getFilteredAppointments()?.map((turno, i) => (
                            <MuiCard key={i} className={` ${classes.detailCardMuiPatientAgendaMedical}`} >
                                <CardContent className={classes.cardContentMuiCardDetailPatient}>
                                    <Box className={classes.divCardContentBottonCallMedical} >
                                        <Box className={classes.medicalCenterIconDetailPatient}>
                                            <FaceIcon className={classes.LocationCityIconDetailPatient} />
                                        </Box>
                                        <Box className={classes.cartillaPhonesSection}>
                                            <Typography className={classes.detailPatientName}>
                                                {turno.pacienteApellidoNombre}
                                            </Typography>
                                        </Box>
                                        <Box className={classes.divCardContentView}>
                                            <Box className={classes.buttonZoneSection}>
                                                <Box>
                                                    {isValidReceptionDate(turno.turnoFechRecepcion) && (
                                                    <CustomButton
                                                        title={"LLAMAR"}
                                                        customClass={`${classes.lightLinearGradient} ${classes.buttonCallPatient}`}
                                                        onClick={() => handleCallButton(turno)}
                                                    />
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box className={classes.cartillaPhonesSection}>
                                            <Typography className={classes.detailPatientOpeningHoursClose}>
                                                Hora: {format(new Date(turno.turnoFechHora), "HH:mm")} |
                                                Hora arribo: {isValidReceptionDate(turno.turnoFechRecepcion) ? format(new Date(turno.turnoFechRecepcion), "HH:mm") : ""}
                                            </Typography>
                                        </Box>
                                        <Box className={classes.cartillaPhonesSection}>
                                            <Typography className={classes.detailPatientNameTypeOfCare}>
                                                Tipo de Turno: {getServiceTypeDescription(turno.tipoAtencion)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </MuiCard>
                        ))}
                    </Box>
                )}

                {openCallModal && (
                    <ModalCallPatient
                        open={openCallModal}
                        onClose={handleCloseModal}
                        title="Llamando paciente"
                        callAttempts={callAttempts}
                        countdown={countdown}
                        isButtonDisabled={isButtonDisabled}
                        handleEnter={handleEnter}
                        handleRetry={handleRetry}
                    />
                )}
                </Box>
            </Box>
        </>
    );
};

export default React.memo(PatientDetails, (prevProps, nextProps) => {
    return prevProps.agendaMedical === nextProps.agendaMedical;
});